export function normalizeNbsp(value: string | null | undefined): string {
  if (value === null || value === undefined) return '';
  return String(value)
    .replace(/\u00A0/g, ' ')
    .replace(/&nbsp;/gi, ' ');
}

export default normalizeNbsp;
